// Bandito wishlist (favoriler) — hesap gerektirmeyen, localStorage tabanlı.
// - <wishlist-button> : ürün kartı/PDP kalp butonu (ekle/çıkar)
// - [data-wishlist-count] : header favori sayacı
// - <wishlist-page> : favoriler sayfası listeleyici
(function () {
  var KEY = 'bandito:wishlist';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: items } }));
  }

  function has(id) {
    id = String(id);
    return read().some(function (i) {
      return String(i.id) === id;
    });
  }

  function toggle(item) {
    var items = read();
    var idx = items.findIndex(function (i) {
      return String(i.id) === String(item.id);
    });
    if (idx >= 0) {
      items.splice(idx, 1);
      write(items);
      return false;
    }
    items.unshift(item);
    write(items);
    return true;
  }

  function remove(id) {
    write(
      read().filter(function (i) {
        return String(i.id) !== String(id);
      })
    );
  }

  function count() {
    return read().length;
  }

  // Sekmeler arası senkron
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: read() } }));
    }
  });

  // --- Kalp butonu ---
  var HEART =
    '<svg viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M12 20.7 4.3 13a4.6 4.6 0 0 1 0-6.5 4.6 4.6 0 0 1 6.5 0l1.2 1.2 1.2-1.2a4.6 4.6 0 0 1 6.5 0 4.6 4.6 0 0 1 0 6.5L12 20.7Z" ' +
    'stroke="currentColor" stroke-width="1.6" fill="var(--wishlist-fill, none)" stroke-linejoin="round"/></svg>';

  var WishlistButton = function () {};
  if (typeof HTMLElement !== 'undefined') {
    WishlistButton = class extends HTMLElement {
      connectedCallback() {
        this.item = {
          id: this.dataset.productId,
          handle: this.dataset.productHandle,
          title: this.dataset.productTitle,
          url: this.dataset.productUrl,
          image: this.dataset.productImage,
          price: this.dataset.productPrice,
        };
        this.btn = this.querySelector('button');
        if (!this.btn) return;
        this.render();
        this._onClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          toggle(this.item);
          this.render();
        };
        this.btn.addEventListener('click', this._onClick);
        this._onChange = () => this.render();
        document.addEventListener('wishlist:change', this._onChange);
      }
      disconnectedCallback() {
        document.removeEventListener('wishlist:change', this._onChange);
        if (this.btn && this._onClick) this.btn.removeEventListener('click', this._onClick);
      }
      render() {
        var active = has(this.item.id);
        this.classList.toggle('is-active', active);
        if (this.btn) {
          this.btn.setAttribute('aria-pressed', active ? 'true' : 'false');
          this.btn.setAttribute('aria-label', active ? 'Remove from favorites' : 'Add to favorites');
        }
      }
    };
    if (!customElements.get('wishlist-button')) customElements.define('wishlist-button', WishlistButton);
  }

  // --- Header sayacı ---
  function updateCounts() {
    var c = count();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = c;
      el.hidden = c === 0;
    });
  }
  document.addEventListener('wishlist:change', updateCounts);
  document.addEventListener('DOMContentLoaded', updateCounts);
  updateCounts();

  // --- Favoriler sayfası ---
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cardHTML(i) {
    var img = i.image
      ? '<img src="' + esc(i.image) + '" alt="' + esc(i.title) + '" loading="lazy">'
      : '';
    return (
      '<div class="wishlist-card">' +
      '<a class="wishlist-card__media" href="' + esc(i.url) + '">' + img + '</a>' +
      '<button type="button" class="wishlist-card__remove" data-wishlist-remove="' + esc(i.id) + '" aria-label="Remove from favorites">&times;</button>' +
      '<div class="wishlist-card__info">' +
      '<a class="wishlist-card__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
      // Wholesale: fiyat yalnızca onaylı toptancıya (body.b2b-musteri, snippets/b2b-musteri.liquid)
      (i.price && document.body.classList.contains('b2b-musteri') ? '<div class="wishlist-card__price">' + esc(i.price) + '</div>' : '') +
      '</div>' +
      '</div>'
    );
  }

  if (typeof HTMLElement !== 'undefined') {
    class WishlistPage extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-wishlist-grid]');
        this.empty = this.querySelector('[data-wishlist-empty]');
        this.render();
        this._onChange = () => this.render();
        document.addEventListener('wishlist:change', this._onChange);
      }
      disconnectedCallback() {
        document.removeEventListener('wishlist:change', this._onChange);
      }
      render() {
        var items = read();
        if (this.empty) this.empty.hidden = items.length > 0;
        if (!this.grid) return;
        this.grid.hidden = items.length === 0;
        this.grid.innerHTML = items.map(cardHTML).join('');
        this.grid.querySelectorAll('[data-wishlist-remove]').forEach(function (b) {
          b.addEventListener('click', function () {
            remove(b.getAttribute('data-wishlist-remove'));
          });
        });
      }
    }
    if (!customElements.get('wishlist-page')) customElements.define('wishlist-page', WishlistPage);
  }

  // Dışarıya minimal API
  window.BanditoWishlist = { read: read, has: has, toggle: toggle, remove: remove, count: count };
})();
